export default __webpack_public_path__ + "static/media/banner-atendimento-mobile.68f4b6c2.png";